import React from 'react';
import SignIn from '../components/Auth/SignIn';

// La coquille (fond, centrage) est portee par AuthCard : ce wrapper posait
// `class=` au lieu de `className=`, son fond n'a donc jamais ete applique.
const SignInPage = () => <SignIn />;

export default SignInPage;
